import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ResourceLoading } from "../../utils/ResourceLoading";
import { format } from "date-fns";
import { nb } from "date-fns/locale";
import { PaperAirplaneIcon, DocumentTextIcon, UserIcon } from "@heroicons/react/24/outline";

export default function OfferHistory({ offer }) {
  const { t } = useTranslation();
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (offer?.id) {
      loadHistory();
    }
  }, [offer?.id]);

  const loadHistory = async () => {
    setIsLoading(true);
    try {
      // TODO: Implement API call to fetch offer history
      // const response = await fetchOfferHistory(order.id);
      // setHistory(response.data || []);
      
      // Mock data for now
      setHistory([
        {
          id: 1,
          action: "sent",
          recipient: "kunde@example.com",
          sent_by: "Ola Nordmann",
          sent_at: new Date().toISOString(),
          status: "delivered",
        },
      ]);
    } catch (error) {
      console.error("Error loading history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <ResourceLoading />;
  }

  return (
    <div className="bg-white shadow-sm rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">
          Send historikk
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Oversikt over alle ganger dette tilbudet har blitt sendt.
        </p>
      </div>
      <div className="px-6 py-6">
        {history.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <PaperAirplaneIcon className="h-12 w-12 mx-auto text-gray-400 mb-4" />
            <p>Ingen send historikk ennå.</p>
            <p className="text-sm mt-2">Når du sender tilbudet vil det vises her.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {history.map((item) => (
              <div
                key={item.id}
                className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <PaperAirplaneIcon className="h-6 w-6 text-blue-600" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <h4 className="text-md font-semibold text-gray-900">
                        Sendt til {item.recipient}
                      </h4>
                      <span className="text-xs text-gray-500">
                        {format(new Date(item.sent_at), "d. MMM yyyy, HH:mm", { locale: nb })}
                      </span>
                    </div>
                    <div className="mt-2 flex items-center gap-4 text-sm text-gray-600">
                      <div className="flex items-center gap-1">
                        <UserIcon className="h-4 w-4" />
                        <span>Sendt av: {item.sent_by}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <span className={`px-2 py-1 rounded text-xs ${
                          item.status === "delivered" 
                            ? "bg-green-100 text-green-800"
                            : item.status === "pending"
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-red-100 text-red-800"
                        }`}>
                          {item.status === "delivered" ? "Levert" : item.status === "pending" ? "Venter" : "Feilet"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}


